import { cn } from '@/lib/utils';

export interface ChipOption {
  value: string;
  label: string;
}

export function ChipGroup({
  label,
  options,
  selected,
  onToggle,
  counts,
}: {
  label: string;
  options: ReadonlyArray<ChipOption>;
  selected: Set<string> | string;
  onToggle: (value: string) => void;
  counts?: Record<string, number>;
}) {
  const isSelected = (value: string) =>
    typeof selected === 'string' ? selected === value : selected.has(value);

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <div className="flex flex-wrap gap-1.5">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onToggle(opt.value)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-all',
              isSelected(opt.value)
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-border bg-background text-muted-foreground hover:border-primary/50 hover:text-foreground',
            )}
          >
            {opt.label}
            {counts && (
              <span className="tabular-nums opacity-70">{counts[opt.value] ?? 0}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
